import React, { Component } from 'react';
import { toJS } from 'mobx';
import { Typography } from '@material-ui/core';
import * as components from '@material-ui/core';
import RichTextEditorRTE from '../../views/CreateNewCase/RichTextEditorRTE/RichTextEditorRTE';
import MultiAddList from '../../views/CreateNewCase/MultiAddList/MultiAddList';
import Card from '../../views/ViewCustomerCase/Card/Card';
import MultiImageUpload from '../../views/CreateNewCase/MultiImageUpload/MultiImageUpload';
import CasePictureCarousel from '../../views/ViewCustomerCase/CasePictureCarousel/CasePictureCarousel';
import PictureGrid from '../../views/ViewCustomerCase/PictureGrid/PictureGrid';
import Table from '../../views/ViewCustomerCase/Table/Table'

import { inject, observer } from 'mobx-react';
import { MenuItem, SelectField, TextField } from 'material-ui';
import ImageUploadButton from '../../views/CreateNewCase/ImageUploadButton/ImageUploadButton';
import { getMuiTheme } from 'material-ui/styles';
import PropTypes from 'prop-types';
import { schemaToObject } from '../../utils/schemaUtil';
import { merge, get } from 'lodash';
import StatefulSelect from '../StatefulSelect/StatefulSelect';
import Parser from 'html-react-parser';
import permissions from '../../permissions';

@inject('languageStore')
@inject('formDataStore')
@inject('customerCaseStore')
@observer
class JsonForm extends Component {
    constructor(props) {
        super(props);

        this.formDataStore = props.formDataStore;
        this.customerCaseStore = props.customerCaseStore;
        this.mode = props.mode || 'view';

        this.data = props.data || props.formDataStore.customerCase;
        this.schema = toJS(props.schema);
        let plainData = schemaToObject(this.schema);
        this.formDataStore.customerCase = merge({},  plainData, toJS(this.data));

        this.getscui = this.getscui.bind(this);
    }

    isEditing() {
        return this.mode === 'edit';
    }

    static childContextTypes = {
        muiTheme: PropTypes.object.isRequired
    }

    getChildContext() {
        return {
            muiTheme: getMuiTheme()
        }
    }

    schemaToElements(schema, key='', path=[]) {
        let children = [];

        if (!schema || key.startsWith('ui:') || typeof schema !== 'object') {
            return null;
        } else if (Array.isArray(schema) || schema.type === 'Array') {
            return this.schemaToElement(schema, key, children, path);
        } else if (typeof schema === 'object') {
            for (var _key in schema) {
                let nextPath = (!schema[_key].type && (_key === 'fields' || schema[_key].fields)) ? path : [...path, _key];
                let schemaElement = this.schemaToElements(schema[_key], _key, nextPath);
                if (schemaElement) {
                    children.push(schemaElement);
                }
            }
        }

        return this.schemaToElement(schema, key, children, path);
    }

    getLabelTranslation(label) {
        if (typeof label === 'object') {
            label = label[this.props.labelLanguage];
        }

        return label;
    }

    renderSelectOptions(schema) {
        let options = [];

        let optionsRange = this.getscui(schema, 'optionsRange');
        if (optionsRange) {
            let { from, to, prefix } = optionsRange;
            prefix = prefix || '';

            for (let i = from || 1; i < to; i++) {
                options.push(`${prefix}${i}`);
            }
        } else {
            options = this.getscui(schema, 'options');
        }

        return Object.keys(options).map((key) => {
            let label = this.getLabelTranslation(options[key]);
            return <MenuItem key={key} value={label}>{label}</MenuItem>;
        });
    }

    getscui(schema, key, deflt) {
        let value = schema["ui:" + key];
        if (value !== undefined && value[this.mode]) return value[this.mode];
        else if (value !== undefined) return value;
        else return deflt;
    }

    getValue(path) {
        return this.isEditing()
        ? this.formDataStore.findObjectReference('customerCase', path)
        : get(
            this.data.translations.find(translation =>
                translation.lang === this.props.language
            ) || this.data.translations[0]
            ,path);
    }

    onChange(path) {
        return (value) => {
            value = typeof value === 'object' ? value.target.value : value;
            this.formDataStore.assignValueToPath('customerCase', path, value);
        }
    }

    schemaToElement(schema, key, children=[], path) {
        let decorator = this.getscui(schema, 'decorator', (schema.type || (Array.isArray(schema) ? "array" : null)));

        if (this.getscui(schema, 'visible') === false || typeof decorator !== 'string')
            return children;

        let requiredUserLevel = this.getscui(schema, 'permission', permissions.levels.user);
        let userLevel = this.customerCaseStore.currentUser.templateRightsLevel;
        if (!permissions.is(requiredUserLevel, userLevel)) {
            return null;
        }

        let Container = components[this.getscui(schema, 'container')] || components.Grid;
        let containerProps = this.getscui(schema, 'containerProps', {className: 'container'});

        let componentProps = this.getscui(schema, 'componentProps', {});
        let labelProps = this.getscui(schema, 'labelProps', {});

        let changeHandler = this.onChange(path).bind(this);
        let label = this.getLabelTranslation(this.getscui(schema, 'label'));
        let value = this.getValue(path);

        // Skip empty value fields
        if (this.mode === 'view' && schema.type && (value == null || value.length < 1)) {
          return;
        }

        switch (decorator.toLowerCase()) {
            case "group": {
                return (
                    <Container {...containerProps}>
                        <components.Grid xs={12}>
                            <Typography variant="subheading" color="primary" gutterBottom {... labelProps}>{label}</Typography>
                        </components.Grid>

                        {children}
                    </Container>
                );
            }

            case "string":
            case "number": return (
                <Container {...containerProps}>
                    <Typography variant="subheading" {... labelProps}>{label}</Typography>
                    {
                        this.isEditing()
                            ? <TextField defaultValue={value} onChange={changeHandler} name={key} fullWidth {... componentProps}/>
                            : <Typography variant="body1" {... componentProps}>{Parser((value || '').toString())}</Typography>

                    }
                </Container>
            );

            case "textarea": return (
                <Container {...containerProps}>
                    <Typography variant="subheading" {... labelProps}>{label}</Typography>
                    {
                        this.isEditing()
                            ? <RichTextEditorRTE value={value} onChange={changeHandler} {... componentProps}/>
                            : <Typography variant="body1" {... componentProps}>{Parser((value || '').toString())}</Typography>
                    }
                </Container>
            );

            case "select": {
                return (
                    <Container {...containerProps}>
                        <Typography variant="subheading" {... labelProps}>{label}</Typography>

                        {
                            this.isEditing()
                                ? (
                                    <StatefulSelect value={value} onChange={changeHandler} {... componentProps}>
                                        {this.renderSelectOptions(schema)}
                                    </StatefulSelect>
                                )

                                : <Typography variant="body1" {... componentProps}>{value}</Typography>
                        }
                    </Container>
                );
            }

            case "array":
            case "list": {
                let fields = schema.fields;

                let tableData = {
                    tableTargetArray: path,
                    keyDataTypes: {},
                    tableDataModel: {},
                    tableColHeaders: [],
                    tableColKeys: [],
                    isSingle: false
                };

                if (fields[0].type && typeof fields[0].type === 'string') {
                    let colData = fields[0];
                    tableData.keyDataTypes[key] = colData.type;
                    tableData.tableDataModel = "";
                    tableData.tableColHeaders.push(this.getLabelTranslation(this.getscui(colData, 'label')));
                    tableData.tableColKeys.push(key);
                    tableData.isSingle = true;
                } else {
                    tableData = Object.keys(fields[0]).reduce((acc, col) => {
                        let colData = fields[0][col];

                        if (this.getscui(colData, 'visible') !== false) {
                            acc.keyDataTypes[col] = colData.type;
                            acc.tableDataModel[col] = '';
                            acc.tableColHeaders.push(this.getLabelTranslation(this.getscui(colData, 'label')));
                            acc.tableColKeys.push(col);
                        }

                        return acc;
                    }, tableData);
                }

                return (
                    <Container {...containerProps}>
                        <Typography variant="subheading" {... labelProps}>{label}</Typography>
                        {
                            this.isEditing()
                            ? <MultiAddList tableData={tableData} {... componentProps}/>
                            // : <Table data={value} tableCols={tableData.tableColHeaders}/>
                            : (value.map((row, index) => {
                                if (tableData.isSingle) {
                                    let separator = (tableData.isSingle && index < value.length - 1) ? ', ' : null;
                                    return <Typography variant="body1" {... componentProps} inline>{row}{separator}</Typography>
                                } else {
                                    return (
                                        <components.Grid className="container">
                                            {tableData.tableColKeys.map(key => {
                                                return <Typography variant="body1" {... componentProps}>{row[key]}</Typography>;
                                            })}
                                        </components.Grid>
                                    )
                                }
                            }))
                        }
                    </Container>
                );
            }

            case "table": {
                let fields = schema.fields;
                let headers = [];

                if (fields[0].type && typeof fields[0].type === 'string') {
                    headers.push(this.getLabelTranslation(this.getscui(fields[0], 'label')));
                } else {
                    headers = Object.keys(fields[0]).map((col) => {
                        let colData = fields[0][col];
                        if (this.getscui(colData, 'visible') !== false) {
                            return this.getLabelTranslation(this.getscui(colData, 'label'));
                        }
                    });
                }

                return (
                    <Container {...containerProps}>
                        <Typography variant="subheading" {... labelProps}>{label}</Typography>
                        <Table data={value} tableCols={headers} {... componentProps}/>
                    </Container>
                )
            }

            case "image": {
                return (
                    <Container {...containerProps}>
                        <Typography variant="subheading" {... labelProps}>{label}</Typography>
                        {
                            this.isEditing()
                                ? <ImageUploadButton onChange={changeHandler} {... componentProps}/>
                                : (
                                    <img
                                        src={'/api/v1/images/' + value}
                                        alt={key}
                                        {... componentProps}
                                    />
                                )
                        }
                    </Container>
                )
            }

            case "multiimage": {
                return (
                    <Container {...containerProps}>
                        <Typography variant="subheading" {... labelProps}>{label}</Typography>

                        {
                            this.isEditing()
                                ? <MultiImageUpload path={path}/>
                                : (
                                    <div>
                                        <CasePictureCarousel data={value} />
                                        <PictureGrid data={value} {... componentProps}/>
                                    </div>
                                )
                        }
                    </Container>
                )
            }

            case "card": {
                return (
                    <Container {...containerProps}>
                        {
                            this.isEditing()
                                ? (
                                    <div>
                                        <Typography variant="subheading" {... labelProps}>{label}</Typography>
                                        <TextField defaultValue={value} onChange={changeHandler} name={key} fullWidth {... componentProps}/>
                                    </div>
                                )
                                : <Card title={label} highlight={value} {... componentProps}/>
                        }
                    </Container>
                )
            }

            case "divider": {
                return (
                    <Container {...containerProps}>
                        <components.Divider/>
                    </Container>
                )
            }
        }
    }

    _render() {
        let html = this.schemaToElements(this.schema);
        return html;
    }
    render() {
        return this._render();
    }
}

export default JsonForm;



// WEBPACK FOOTER //
// ./src/components/JsonForm/JsonForm.jsx